<template>
	<v-app>
		<div ref="body" id="body" :style="'background-color: ' + (backgroundColor + ';' + ($route.meta.backgroundImage ? 'background: url(' + $route.meta.backgroundImage + ')' : ''))">
			<div id="app" :style="'min-height: ' + minHeight + '; padding-bottom:' + padding">
					<router-view :key="$route.query"></router-view>
					<MenuBar v-if="$route.meta.bottomMenu && !$route.query.inModal && !$route.query.nomenu" />
			</div>
		</div>
	</v-app>
</template>

<script>
import MenuBar from './components/elements/MenuBar.vue';
import {version} from '../package';

export default {
	name: 'App',
	components: {
		MenuBar
	},
	watch: {
		'$route' (to) {
			console.log('Route changed to ' + to.path); 
			this.trackEvent('App', 'Navigation', to.path);
			document.body.classList.remove('chat-active');
			document.body.classList.remove('hide-nav-bar');
		}
	},
	data() {
		return {
			defaultBackgroundColor: "var(--background-color-main)",
			isDarkMode: false
		}
	},
	methods: {
		getDeviceType() {
			const userAgent = navigator.userAgent;
			return userAgent;
		},
		trackEvent: function(eventCategory, eventSubCategory, name, onSuccess = null) {
			// if there's a parameter in the route, add it to the request body as 'data' and remove it from the eventSubCategory
			const data = this.$route.params;
			const deviceType = this.getDeviceType();
			const appVersion = version;
			// platformInfo is the contents of the first set of brackets in deviceType
			const platformInfo = deviceType.match(/\((.*?)\)/)[1];
			console.log('platformInfo:', platformInfo);
			console.log('appVersion:', appVersion);
			const requestBody = {
				eventCategory: eventCategory,
				eventSubCategory: eventSubCategory,
				name: name,
				appVersion: appVersion,
				platformInfo: platformInfo
			};

			// Only include data if the object has properties
			if (Object.keys(data).length > 0) {
				// Use just the ID value instead of the entire params object
				const idValue = Object.values(data)[0];
				requestBody.data = idValue;
				// Remove the ID from the eventSubCategory path
				requestBody.name = name.replace('/' + idValue, '');
			}
			var url = this.$route.meta.api + "/Customers/00000000-0000-0000-0000-000000000000/Events";
			
			//console.log(this.$http.defaults.headers.common["Authorization"], 'Auth header');
			if (!this.$http.defaults.headers.common["Authorization"]) {
				if (this.$cookies.get('token')) {
					this.$http.defaults.headers.common = { "Authorization": "bearer " + this.$cookies.get('token')};
				}
			}

			if(this.$http.defaults.headers.common["Authorization"]){
				this.$http.post(url, requestBody)
					.then((response) => {
						if (onSuccess) {
							onSuccess(response.data);
						}
					})
					.catch((result) => {
						console.log('error', result);
					});
			} else {
				console.log('No auth header so skipping logging');
			}

		}
	},
	computed: {
		backgroundColor() {
			// Check if dark mode is enabled and this is an admin route
			if (this.$root.isDarkMode && this.$route.meta.requiresAdmin) {
				return 'var(--background-dark-mode)';
			}

			if (this.$route.meta.backgroundColor){
				return this.$route.meta.backgroundColor;
			}
			if (this.$route.query.theme)
			{
				return this.$route.query.theme === 'dark' ? '#332847' : 'white';
			}
			return this.defaultBackgroundColor;
		},
		minHeight(){
			//console.log(this.$route.meta.bottomMenu, 'bottom menu');
			var ret = 'calc(100vh - ' + (this.$route.meta.bottomMenu ? 60 : 0) + 'px)';
			//console.log(ret, 'Min Height');
			return ret;
		},
		padding(){
			//console.log(this.$route.meta.bottomMenu, 'bottom menu');
			var c = this.$cookies.get('sb');
			var sb = 0;
			if (c) {
				sb= parseInt(c);
			}
			var ret = (this.$route.meta.bottomMenu ? (80 + sb) : 0) + 'px';
			//console.log(ret, 'Padding');
			return ret;
		},
	},
}
</script>

<style>

:root {

	--text-color: #281C3B;
	--light-text-color: white;
	--grey-text: #8b8b8b;

	--border-color: gainsboro;

	--background-color-main: #FAF9F7E5;
	/* --background-color-main: #413655; */

	--background-color: white;
	--background-color-primary: #413655;
	--background-color-alt: #FBF7F4;
	--background-color-alt2: #332847;
	--background-color-alt3: linear-gradient(243.52deg, #FCE5D4 18.85%, #E0C5C8 81.37%);
	--background-color-alt4: linear-gradient(211.44deg, #EEF0FF 17.53%, #D4D9F2 84.89%);
	--background-color-alt5: linear-gradient(104.23deg, #D5C9C8 0%, #E9E0DE 60.23%);
	--background-color-alt6: #C6CAE5;
	--background-color-vourcher-default: #02549F;
	--background-dark-mode: #0f0f1e;

	--whatsapp-green: #25D366;

	--border-radius-xs: 4px;
	--border-radius-s: 8px;
	--border-radius-m: 12px;
	--border-radius-l: 16px;
	--border-radius-xl: 22px;

	--box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.072);

}

/* Light mode (default) */
:root.light-mode {
	--admin-bg-primary: #f8f9fa;
	--admin-bg-secondary: #ffffff;
	--admin-text-primary: #212529;
	--admin-text-secondary: #6c757d;
	--admin-border: #dee2e6;
	--admin-hover-bg: #f1f3f5;
	--admin-active-bg: #e9ecef;
}

/* Dark mode */
:root.dark-mode {
	--admin-bg-primary: #1a1a2e;
	--admin-bg-secondary: #16213e;
	--admin-text-primary: #e0e0e0;
	--admin-text-secondary: rgba(224, 224, 224, 0.6);
	--admin-border: rgba(224, 224, 224, 0.2);
	--admin-hover-bg: rgba(224, 224, 224, 0.05);
	--admin-active-bg: rgba(224, 224, 224, 0.15);
}

/* Dark theme - chat/app-wide */
:root {
	--dark-bg-primary: #2f2f2f;
	--dark-bg-secondary: #404040;
	--dark-bg-hover: #4a4a4a;
	--dark-border: #555;
	--dark-text-primary: #e8e4df;
	--dark-text-secondary: #888;
	--dark-accent: #c4967a;
}

@font-face {
	font-family: 'Gotham';
	src: url('assets/Gotham-Book.ttf');
	font-display: block;
}

@font-face {
	font-family: 'Gotham-Heavy';
	src: url('assets/Gotham-Medium.ttf');
	font-display: block;
}

* { font-family: 'Gotham'; }

/* Actual HTML body element outside of app control */
body{
	margin:0px;
	background-color:var(--background-color-main);
	color: var(--text-color);
	font-size: 12px;
	min-height: calc(100vh);
	font-family: gotham-heavy;
	user-select: none;
	/* overflow-x: hidden; I HAVE REMOVED THIS BECAUSE IT BROKE THE STICKY HEADER BAR... BUT THE HOMEPAGE IS NOW WOBBLING SIDE TO SIDE AGAIN.  FIND CAUSE AND FIX*/
}

/* 'Our' HTML body element inside app control */
#body {
	background-color:var(--background-color-main);
	padding-left: 30px;
	padding-right: 30px;
	margin: 0px;
	padding-top: 10px;
	m--argin-bottom: 78px;
	background-position: center !important;
	background-size: cover !important;
	background-repeat: no-repeat !important;
}

html {
	height: 100vh;
}

#app
{
	background-color:transparent;
	min-height: calc(100vh - 60px);
}

h1 {
	font-size: 32px;
	margin-bottom: 8px;
	font-family: gotham;
}

.bold {
	font-family: gotham-heavy;
}

strong {
	font-family: gotham-heavy;
}

h2 {
	font-size: 16px;
	margin-bottom: 8px;
	font-family: gotham;
}

p {
	margin-bottom: 9px;
	font-family: gotham;
	f--ont-weight: lighter;
	font-size: 15px;
}

.middle-page {
	position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%)
}

.middle-page-topthird {
	position: absolute; top: 30%; left: 50%; transform: translate(-50%, -50%);
	z-index: 9999;
}

.v-label {
	font-size: small !important;
	color: var(--text-color) !important;
	opacity: 100 !important;
	font-size: 12px !important;
}

.pageHeaderIcon {
	width: 40px;
	margin-bottom: 20px;
	/* margin-right:auto;
	margin-left:auto;
	display: block; */
}

.pageHeaderIconBigger {
	width: 80px;
	margin-bottom: 20px;
	/* margin-right:auto;
	margin-left:auto;
	display: block; */
}

.mg-button {
		display: block !important;
		border-radius: 30px !important;
		height: 50px !important;
		background-color: var(--text-color) !important;
		color: var(--light-text-color) !important;
		text-decoration: none !important;
		text-transform: capitalize !important;
		padding-right: 30px !important;
		padding-left: 30px !important;
		margin-top: 10px !important;
		margin-right: auto !important;
		margin-left: auto !important;
		width: 80% !important;
		margin-top: 30px !important;
		font-family: gotham-heavy;
}
.mg-button.no-caps {
		text-transform: none !important;
}

.mg-button.outline{
	background-color: white !important;
	border: 1px solid var(--text-color) !important;
	color: var(--text-color) !important;
}

.mg-button.textOnly {
	text-align: center;
	font-size: 15px;
	font-weight: bold;
	margin-top: 12px;
	background-color: transparent !important;
	color: var(--text-color) !important;
}


.mg-select {
		display: block !important;;
		border-radius: 30px !important;
		height: 50px !important;
		background-color: var(--text-color) !important;
		color: var(--light-text-color) !important;
		text-decoration: none !important;
		text-transform: capitalize !important;
		padding-right: 10px !important;
		padding-left: 10px !important;
		margin-right: auto !important;
		margin-left: auto !important;
		width: 80% !important;
		margin-top: 30px !important;
		font-family: gotham-heavy;
		.v-field--variant-filled .v-field__overlay {
			margin-top:-10px;
			background-color: transparent !important;
		}
		.v-field__input {
			padding-top: 10px !important;
		}
		.v-field__append-inner {
			margin-top: -6px;
		}

}

.centered {
	text-align: center;
}

.left {
	text-align: left;
}

.right {
	text-align: right;
}

.blur {
	opacity: 0.7;
	filter: blur(1.2px);
}

a {
	text-decoration: none;
	color: unset;
}

.topTabButton
{
	border: 1px solid var(--border-color) !important;
	border-radius: 4px !important;
	font-size: 11px !important;
	padding: 10px !important;
	box-shadow: none !important;
	m--argin:0px !important;
	background-color: transparent !important;
	color: var(--text-color) !important;
	width: 100% !important;
}

.active
{
	background-color: var(--text-color) !important;
	color: var(--light-text-color) !important;
}

.v-navigation-drawer__scrim {
	background-color: var(--background-color) !important;
	opacity: 0 !important;
}

.v-enter-active,
.v-leave-active {
	transition: opacity 0.4s ease;
}

.v-enter-from,
.v-leave-to {
	opacity: 0;
}

.right {
	text-align: right;
}

.allowYScrollContainer
{
	overflow: scroll;
	scrollbar-width: none;
}

.allowYScrollContent {
	display: inline-block;
	white-space: nowrap;
}

.nowrap {
	overflow: hidden;
	text-wrap: nowrap;
	max-width: 100%;
	display: block;
	text-overflow: ellipsis
}

.no-top-padding {
	padding-top: 0px !important;
}

.tp-7 {
	padding-top: 7px !important;
}

.tp-4 {
	padding-top: 4px !important;
}

.tp-2 {
	padding-top: 2px !important;
}

.v-skeleton-loader {
	background-color: transparent !important;
}

.v-slider-thumb__surface {
		background-color: #332847 !important;
		border: 3px solid white !important;
}

.v-slider-track__background {
	background-color: #FFFFFF66 !important;
}

.v-slider-track__fill {
	background-color: white !important;
}

.v-progress-linear {
	background: #FFFFFF33 !important;
	w--idth: 80%;
}

.v-progress-linear__determinate {
	background: white;
}

.anchor-bottom {
	position: fixed;
	bottom: 60px;
	width: calc(100vw - 60px);
}

.anchor-bottom-no-nav {
	position: fixed;
	bottom: 30px;
	width: calc(100vw - 60px);
}

@media(max-height: 670px) {
	.anchor-bottom {
		margin-top: 10px;
		position: unset;
		padding-bottom: 30px;
	}
}

.small {
	font-size: 10px;
}

.simplePage {
	text-align: center;
	padding-bottom: 30px;
	h1 {
		margin-top: 45px;
		margin-bottom: 20px;
		font-size: 32px;
	}
	p {
		margin-bottom: 20px;
	}
	.smallHeroImg {
		width: 120px;
		margin-top: 20px;
		margin-bottom: 30px;
		font-size: 100px;
		color: var(--text-color)
	}
	.heroImg {
		width: 160px;
		margin-top: 40px;
		margin-bottom: 30px;
	}
	.largeHeroImg {
		width: 100%;
		margin-top: 40px;
		margin-bottom: 30px;
	}
	.v-field__overlay {
		border: 1px solid black !important;
	}
}

.mgTextField {
	.v-field__overlay {
		border: 1px solid black !important;
	}
}

@media(max-height: 760px) {
	.simplePage .heroImg {
		width:120px !important;
		margin-top: 20px !important;
	}
	.simplePage h1 {
		margin-top: 10px !important;
	}
}

.well {
	margin-top: 20px;
	margin-bottom: 20px;
	padding: 25px;
	background-color: #f5f3f5;
	border-radius: 24px;
	h1{
		font-size: 16px;
	}
	h2{
		font-size: 14px;
	}
}

.hubItemWrapper {
	margin-top: 12px; 
	margin-bottom: 12px;
	margin-left: 0px; 
	padding-right: 10px;
	padding-left: 0px;
	width: calc((100vw - 60px) / 2);
	float: left !important;
}

.hubItemWrapper:nth-child(even) {
	padding-right: 0px;
	padding-left: 10px;
	float:right !important;
}

.shadowed {
	box-shadow: 0px 4px 8px 0px rgba(51, 40, 71, 0.05);
}

.floatRight {
	float: right;
}

.floatLeft {
	float: left;
}

.verticalCenter {
	/* display: flex;
	align-items: center; */
	margin-top: auto;
	margin-bottom: auto;
}

@media(max-height: 760px) {
	.onlyTallScreen {
		display: none;
	}
}

@media(max-height: 600px) {
	.withNoKeyboard {
		display: none;
	}
}

.smoothScrollContainer {
	padding: 18px;
	margin-left: -46px;
	margin-right: -46px;
}

.smoothScrollContainerItem {
	margin-top: 12px; 
	margin-bottom: 12px;
	margin-left: 0px; 
	padding-right: 10px;
	padding-left: 0px;
	width: calc((100vw - 60px) / 2);
	float: left !important;
}

.smoothScrollContainerItem:first-child {
	margin-left: 30px;
}

.smoothScrollPanel {
	margin-right: 15px;
	float: left;
	width: calc(100vw - 75px) !important;
}

.smoothScrollPanel:first-child {
	margin-left: 27px;
}

.smoothScrollPanel:last-child {
	margin-right: 27px;
}

/* Hide any drawer except the chat drawer, quiz drawers, walkthrough drawer, and hide-nav-drawer when nav bar should be hidden */
body.hide-nav-bar .drawer:not(.chatDrawer):not(.hide-nav-drawer):not(:has([class*="quiz-"])):not(:has([class*="walkthrough-"])) 
{
  display: none !important;
}

/* Hide the bottom menuBar when drawer or chat is active */
body.hide-nav-bar .menuBar {
  display: none !important;
}

</style>
